import UiDetail from "./UiDetail";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumPipe } from "@/models/EnumPipe";
import UiGroup from "./UiGroup";

/**
 * 英文包装种类详细
 * @description 自动生成的代码,请勿修改
 */
export default class DtoDetailPackageEn extends UiDetail<string> {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * 英文名称
     */
    Name?: string;
    /**
     * 英文简写
     */
    Abbr?: string;
    /**
     * 海关代码
     */
    Code?: string;
}

/**
 * 英文包装种类详细-表单校验
 */
export const DtoDetailPackageEnRules = {
}

/**
 * 英文包装种类详细-设置项
 */
export const DtoDetailPackageEnMiezzDetailItems: MiezzFormItem[] = [
  {
    Prop: "Name",
    Label: "英文名称",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Abbr",
    Label: "英文简写",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Code",
    Label: "海关代码",
    Type: EnumMiezzFormItemType.Text,
  },
]
